import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FirebaseService } from 'src/app/services/firebase.service';

@Component({
  selector: 'app-adminbackend',
  templateUrl: './adminbackend.component.html',
  styleUrls: ['./adminbackend.component.css']
})
export class AdminbackendComponent implements OnInit {

  adminIn:boolean= false;
  
  
  constructor(private r:Router, private ar:ActivatedRoute, private fs: FirebaseService) {
    
   }

  ngOnInit(): void {
  }

  logOut(){
    this.fs.adminLout();
    this.r.navigateByUrl('adminpanel');
  }

  goNewPlan(){
    this.r.navigate(['createplan'],{relativeTo: this.ar});
  }

  goAllPlans(){
    this.r.navigate(['allplans'],{relativeTo: this.ar});
  } 

  goMessages(){
    this.r.navigate(['messages'],{relativeTo: this.ar});
  }
  
  goManageUsers(){
    this.r.navigate(['manageusers'],{relativeTo: this.ar});
  }

  goManageOrders(){
    this.r.navigate(['manageorders'],{relativeTo: this.ar});
  }


}
